const AssetAllocationHeader = () => {
  return (
    <div>
      <p className="text-gray-600 mb-4">
        How is your portfolio currently allocated? Total allocation must equal 100%.
      </p>
    </div>
  );
};

export default AssetAllocationHeader;